import React from 'react';

import { useIntl } from 'react-intl';

import { TextInput } from 'components/ucl';

interface IFavoriteInput {
  errorMessage?: string;
  favoriteName?: string;
  onChange: (value: string) => void;
  testID?: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const FavoriteInput: React.FC<IFavoriteInput> = ({
  errorMessage = '',
  favoriteName,
  onChange,
  testID,
  setErrorMessage,
}) => {
  const { formatMessage } = useIntl();

  const setInputErrorMessage = (favoriteName: string) => {
    setErrorMessage(!favoriteName ? formatMessage({ id: 'saveFavoriteOrderNameError' }) : '');
  };

  const favoriteNameValue = favoriteName ?? '';

  return (
    <TextInput
      testID={testID}
      autoFocus
      required
      label={formatMessage({ id: 'orderName' })}
      value={favoriteNameValue}
      onChangeText={value => {
        setInputErrorMessage(value.trim());
        return onChange(value);
      }}
      onBlur={() => {
        setInputErrorMessage(favoriteNameValue);
      }}
      errorMessage={errorMessage}
      aria-label={errorMessage ? errorMessage : formatMessage({ id: 'orderName' })}
    />
  );
};
